export interface SavedPaymentMethod {
  paymentMethodId: string;
  paymentType?: string | null;
  last4?: string | null;
  brand?: string | null;
  linkEmail?: string | null;
  isDefault?: boolean | null;
}

// "Visa ····4242", "Bank account ····6789", "Link (ada@example.com)": the one
// description a saved method gets everywhere a parent sees it.
export function describePaymentMethod(method: SavedPaymentMethod): string {
  if (method.paymentType === 'link') {
    return method.linkEmail ? `Link (${method.linkEmail})` : 'Link';
  }
  const label = method.paymentType === 'us_bank_account' ? 'Bank account' : (method.brand ?? 'Card');
  const name = label.charAt(0).toUpperCase() + label.slice(1);
  return method.last4 ? `${name} ····${method.last4}` : name;
}
